const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  email: state => state.user.email,
  introduction: state => state.user.introduction,
  status: state => state.user.status,
  roles: state => state.user.roles,
  setting: state => state.user.setting,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  errorLogs: state => state.errorLog.logs,
  errorMsg: state => state.errorMsg.ERR_MSG,
  errorCode: state => state.errorMsg.ERR_CODE,
  userId: state => state.user.id,
  username: state => state.user.username,
  userDetailInfoId: state => state.user.userDetailInfoId,
  userDetailInfoGetted: state => state.user.userDetailInfoGetted,
  userInfoGetted: state => state.user.userInfoGetted,
  unReadMsg: state => state.user.unReadMsg,
  unReadMsgNum: state => state.user.unReadMsgNum,
  detailMsg: state => state.user.detailMsg,
  channelInfo: state => state.user.channelInfo
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js